import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the FeedbackPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-feedback',
  templateUrl: 'feedback.html',
})
export class FeedbackPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    // console.log('ionViewDidLoad FeedbackPage');
    var imgObj = <HTMLImageElement>document.getElementById('fbimg')
    var imgSrc = this.navParams.get("img")
    imgObj.src = imgSrc
    
  }

}



// WEBPACK FOOTER //
// ./src/pages/feedback/feedback.ts